import React from "react";
import SEO from "./SEO";
import Header from "./Header";
import Footer from "./Footer";
import Slider from "react-slick";
import { NavLink } from "react-router-dom";

function About() {
  const settings2 = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1610,
        settings: { slidesToShow: 2, arrows: false, autoplay: true },
      },
      { breakpoint: 700, settings: { slidesToShow: 2, arrows: false } },
      { breakpoint: 576, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <>
      <SEO
        title="About Us | Moironix Soft Solutions"
        description="Moironix Soft Solutions Delivers Smart Software, Web, and App Solutions with Expert Support, Ensuring Innovation, Reliability, and Business Growth"
        keywords="Custom Software Development, Software Solutions for Enterprises, Top Software Development Companies in Hyderabad, Best Software Companies in Hyderabad, Best IT companies in Hyderabad, Best Software Company in Hyderabad, Software Company in Hyderabad, Top Software Company in Hyderabad, Top 5 Software Company in Hyderabad, Mobile App Development, Custom Mobile App Development Hyderabad, Hybrid App Development Cost, React Native App Development Services, Flutter App Development for Startups, Mobile App Prototype Development, Mobile App Development Company, Android App Development Services, iOS App Development Services, Mobile App Developers, App Development Agency, Enterprise Mobile App Development, Application Development, Custom Web Application Development, PHP Application Development Services, Java Web Application Development, Net Application Development, SaaS Application Development, Web App Maintenance Services, Application Development Services, Web Application Development, Software Application Development, Custom Application Development, Web App Developers, Enterprise Application Development, Website Design and Development, Responsive Website Design, Ecommerce Website Development Cost, Website Redesign Services, Website Speed Optimization Services, Landing Page Design and Development, Website Design Company, Website Development Services, Web Design and Development, Ecommerce Website Development, Custom Website Design, Digital Marketing, Local Seo Services, Social Media Marketing, Content Marketing Strategy, Email Marketing Automation Services, Pay Per Click Management, Conversion Rate Optimization Services, Digital Marketing Agency, Seo Services, Social Media Marketing Services, Content Marketing Services, PPC Management, Digital Marketing Services, Graphic Design, Logo Design, Infographic Design Services, Brand Identity Design Package, Print Design Services, Ui/Ux Graphic Design, Motion Graphic Design Services, Graphic Design Services, Brand Design, Graphic Designers, Ui/Ux Design, Web Graphic Design"
      />
      <Header />
      <div className="prt-page-title-row">
        <div className="prt-page-title-row-inner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-page-title-row-heading">
                  <div className="banner-vertical-block" />
                  <div className="page-title-heading">
                    <h2 className="title">About us</h2>
                  </div>
                  <div className="breadcrumb-wrapper">
                    <span>
                      <NavLink title="Homepage" to="/">
                        Home
                      </NavLink>
                    </span>
                    <span className="action">about us</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="site-main">
        <section className="prt-row about-section01 clearfix">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-lg-6">
                <div className="prt-bg prt-col-bgimage-yes col-bg-img-two">
                  <div className="prt-col-wrapper-bg-layer prt-bg-layer" />
                  <div className="layer-content" />
                </div>
                <img
                  className="img-fluid prt-equal-height-image w-100 position-relative"
                  src="images/bg-image/moironixabout.jpeg"
                  alt="bg-image"
                />
              </div>
              <div className="col-xl-6 col-lg-6">
                <div className="prt-bg spacing-4">
                  <div className="prt-col-wrapper-bg-layer prt-bg-layer">
                    <div className="prt-col-wrapper-bg-layer-inner" />
                  </div>
                  <div className="layer-content">
                    <div className="position-relative">
                      <div className="section-title">
                        <div className="title-header">
                          <h2 className="section-title-h2">
                            Our goal is to provide you with software solutions
                          </h2>
                        </div>
                        <div className="title-desc">
                          <p className="res-991-pb-0">
                            At Moironix Soft Solutions, we are passionate about
                            delivering cutting-edge technology solutions that
                            drive business success. Founded with a vision to
                            empower businesses through digital transformation,
                            we specialize in website development, mobile
                            application development, and custom software
                            solutions. Our commitment to quality, innovation,
                            and client satisfaction sets us apart in the
                            competitive landscape of IT services.
                          </p>
                        </div>
                      </div>
                      <div className="row row-equal-height mt-10">
                        <div className="col-lg-6">
                          <div className="featured-box-main">
                            <h3 className="featured-box-h3">
                              Seamless Integration
                            </h3>
                            <div className="prt-horizontal_sep mt-30 mb-30 border-none res-991-mb-15 res-991-mt-15" />
                            <h3 className="featured-box-h3">
                              Smart Automation
                            </h3>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="featured-box-main">
                            <h3 className="featured-box-h3">
                              Top-notch Security
                            </h3>
                            <div className="prt-horizontal_sep mt-30 mb-30 border-none res-991-mb-15 res-991-mt-15" />
                            <h3 className="featured-box-h3">
                              Scalable Performance.
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="prt-row bg-img2 prt-bgimage-yes prt-bg bg-base-dark testimonial-section clearfix">
          <div className="prt-row-wrapper-bg-layer prt-bg-layer bg-base-dark" />
          <div className="container-fluid">
            <div className="row align-items-center spacing-2">
              <div className="col-lg-3">
                <div className="pr-20 res-1199-pr-0">
                  <div className="prt-custom-counter-content">
                    <h3 className="prt-custom-heading counter is-visible">
                      1000+
                    </h3>
                    <h3 className="custom-heading-h3">Happy Clients</h3>
                  </div>
                  <div className="prt-custom-counter-desc">
                    <p className="counter-desc-p">
                      Our satisfied clients have the best words for our
                      applications.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-9 res-991-mt-20">
                <Slider {...settings2}>
                  <div className="col-lg-4 testimonials-main">
                    <div className="testimonials-style1">
                      <div className="testimonials-style1-content">
                        <div className="testimonial-prt-description">
                          <div className="prt-box-highlight">
                            <h3 className="prt-box-highlight-h3">
                              Exceeded Our Expectations!
                            </h3>
                          </div>
                          <div className="prt-ratting-stars">
                            <ul className="ratting-stars">
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="testimonial-prt-box-desc">
                          <p className="testimonial-prt-box-desc-p">
                            The application streamlined our operations beyond
                            what we imagined. The intuitive design and powerful
                            features have been a game-changer.
                          </p>
                        </div>
                        <div className="prt-box-footer">
                          <h3 className="testimonial-caption-h3">– Sravan M</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 testimonials-main">
                    <div className="testimonials-style1">
                      <div className="testimonials-style1-content">
                        <div className="testimonial-prt-description">
                          <div className="prt-box-highlight">
                            <h3 className="prt-box-highlight-h3">
                              Game-Changer for Our Business
                            </h3>
                          </div>
                          <div className="prt-ratting-stars">
                            <ul className="ratting-stars">
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="testimonial-prt-box-desc">
                          <p className="testimonial-prt-box-desc-p">
                            The transition to this application was smooth, and
                            our team adapted quickly. It saves us hours of work
                            every week.
                          </p>
                        </div>
                        <div className="prt-box-footer">
                          <h3 className="testimonial-caption-h3">
                            – Santhosh T
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 testimonials-main">
                    <div className="testimonials-style1">
                      <div className="testimonials-style1-content">
                        <div className="testimonial-prt-description">
                          <div className="prt-box-highlight">
                            <h3 className="prt-box-highlight-h3">
                              Reliable and Scalable Solution
                            </h3>
                          </div>
                          <div className="prt-ratting-stars">
                            <ul className="ratting-stars">
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="testimonial-prt-box-desc">
                          <p className="testimonial-prt-box-desc-p">
                            This software grows with our business needs. Its
                            robust features and excellent support make it a
                            perfect choice.
                          </p>
                        </div>
                        <div className="prt-box-footer">
                          <h3 className="testimonial-caption-h3">– Murthi p</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 testimonials-main">
                    <div className="testimonials-style1">
                      <div className="testimonials-style1-content">
                        <div className="testimonial-prt-description">
                          <div className="prt-box-highlight">
                            <h3 className="prt-box-highlight-h3">
                              Boosted Our Productivity
                            </h3>
                          </div>
                          <div className="prt-ratting-stars">
                            <ul className="ratting-stars">
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                              <li className="ratting-stars-items">
                                <a href="#" className="ratting-stars-link">
                                  <i
                                    className="fa fa-star"
                                    aria-hidden="true"
                                  />
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="testimonial-prt-box-desc">
                          <p className="testimonial-prt-box-desc-p">
                            Since implementing this software, our workflow has
                            become more streamlined, and our productivity has
                            skyrocketed.
                          </p>
                        </div>
                        <div className="prt-box-footer">
                          <h3 className="testimonial-caption-h3">– Ravi K</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </section>
        <section className="prt-row tab-section clearfix">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="blog-title text-end">
                  <div className="section-title style2">
                    <div className="title-header">
                      <h2>
                        Stay up <span />
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 blog-sm">
                <div className="process-desc process-desc1">
                  <p className="desc-text">
                    Web designing in a powerful way of just not a profession,
                    how in a passion for our Company. We have a to the idea.
                  </p>
                </div>
              </div>
              <div className="col-xl-4 col-lg-3 col-md-12 col-sm-12 blog-sm">
                <div className="blog-title text-end mt-15">
                  <NavLink
                    className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-gradiant"
                    to="/contact"
                  >
                    Upcoming News!
                  </NavLink>
                </div>
              </div>
              <div className="col-xl-8 col-lg-9 col-md-12 col-sm-12">
                <div className="section-title style2 mt-25 res-991-mt-0 res-991-mt_5">
                  <div className="title-header">
                    <h2>to date</h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-25 res-480-mt-0">
              <div className="col-lg-12">
                <div className="prt-tabs tab-style1">
                  <ul className="tabs tabs-menu">
                    <li className="tab active">
                      <a className="tab-links tab-link-text1">Our goals</a>
                    </li>
                    <li className="tab">
                      <a className="tab-links tab-link-text1">Our vision</a>
                    </li>
                    <li className="tab">
                      <a className="tab-links tab-link-text1">Our history</a>
                    </li>
                  </ul>
                  <div className="content-tab">
                    <div className="content-inner active" style={{}}>
                      <div className="content-inner-text">
                        <div className="tabs-style-1-content">
                          <div className="row align-items-center">
                            <div className="col-lg-6">
                              <div>
                                <img
                                  width={1200}
                                  height={749}
                                  className="img-fluid"
                                  alt="tab-image"
                                  src="images/single-img-14.jpeg"
                                  loading="lazy"
                                />
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="tab-content-2 res-991-mt-20">
                                <h3 className="tab-content-h3">
                                  Our firm is an expert to creates
                                </h3>
                                <p>
                                  Well aware of the existing mobile app market
                                  trends to keep tabs on the evolving trend of
                                  the industry, to developing high-gradequality
                                  at the top positions! Web designing in a
                                  powerful way of just not a profession, hony.
                                  We have a tendency to beve.
                                </p>
                              </div>
                              <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                  <div className="list-border-left">
                                    <ul className="tab-list">
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Marketing analysis
                                        </div>
                                      </li>
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Superior Integration
                                        </div>
                                      </li>
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Data visualization
                                        </div>
                                      </li>
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Digital experiences
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                  <div className="pl-20 res-1199-pl-0">
                                    <ul className="tab-list res-575-mt-0">
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Marketing analysis
                                        </div>
                                      </li>
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Machine learning
                                        </div>
                                      </li>
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Business intelligence
                                        </div>
                                      </li>
                                      <li className="tab-list-item last-child">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Team Performance
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="content-inner" style={{ display: "none" }}>
                      <div className="content-inner-text">
                        <div className="tabs-style-1-content">
                          <div className="row align-items-center">
                            <div className="col-lg-6">
                              <div className="tab-content-2">
                                <h3 className="tab-content-h3">
                                  Our firm is an expert to creates
                                </h3>
                                <p>
                                  Well aware of the existing mobile app market
                                  trends to keep tabs on the evolving trend of
                                  the industry, to developing high-gradequality
                                  at the top positions! Web designing in a
                                  powerful way of just not a profession, hony.
                                  We have a tendency to beve.
                                </p>
                              </div>
                              <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                  <div className="list-border-left">
                                    <ul className="tab-list">
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Marketing analysis
                                        </div>
                                      </li>
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Superior Integration
                                        </div>
                                      </li>
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Data visualization
                                        </div>
                                      </li>
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Digital experiences
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                  <div className="pl-20 res-1199-pl-0">
                                    <ul className="tab-list res-575-mt-0">
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Marketing analysis
                                        </div>
                                      </li>
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Machine learning
                                        </div>
                                      </li>
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Business intelligence
                                        </div>
                                      </li>
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Team Performance
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="res-991-mt-20">
                                <img
                                  width={1200}
                                  height={749}
                                  className="img-fluid"
                                  alt="tab-image"
                                  src="images/singleimg-04.jpg"
                                  loading="lazy"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="content-inner" style={{ display: "none" }}>
                      <div className="content-inner-text">
                        <div className="tabs-style-1-content">
                          <div className="row align-items-center">
                            <div className="col-lg-6">
                              <div>
                                <img
                                  width={1200}
                                  height={749}
                                  className="img-fluid"
                                  alt="tab-image"
                                  src="images/single-img-14.jpeg"
                                  loading="lazy"
                                />
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="tab-content-2 res-991-mt-20">
                                <h3 className="tab-content-h3">
                                  Our firm is an expert to creates
                                </h3>
                                <p>
                                  Well aware of the existing mobile app market
                                  trends to keep tabs on the evolving trend of
                                  the industry, to developing high-gradequality
                                  at the top positions! Web designing in a
                                  powerful way of just not a profession, hony.
                                  We have a tendency to beve.
                                </p>
                              </div>
                              <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                  <div className="list-border-left">
                                    <ul className="tab-list">
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Marketing analysis
                                        </div>
                                      </li>
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Superior Integration
                                        </div>
                                      </li>
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Data visualization
                                        </div>
                                      </li>
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Digital experiences
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                  <div className="pl-20 res-1199-pl-0">
                                    <ul className="tab-list res-575-mt-0">
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Marketing analysis
                                        </div>
                                      </li>
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Machine learning
                                        </div>
                                      </li>
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Business intelligence
                                        </div>
                                      </li>
                                      <li className="tab-list-item">
                                        <i className="fas fa-long-arrow-alt-up tab-list-link" />
                                        <div className="tab-list-text">
                                          Team Performance
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}

export default About;
